// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.overview-map {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
}

div.overview-map > button {
    display: none;
}

div.overview-map > div.ol-overviewmap-map {
    position: absolute;
    top: 3.75em;
    left: 0.25em;
    width: 200px;
    height: 200px;
    background-color: white;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.5);
    border: 1px solid var(--border-color);
}

div.overview-map.ol-collapsed > div.ol-overviewmap-map {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./qwc2-wob/plugins/style/OverviewSupport.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,0CAA0C;IAC1C,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB","sourcesContent":["div.overview-map {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 101;\n}\n\ndiv.overview-map > button {\n    display: none;\n}\n\ndiv.overview-map > div.ol-overviewmap-map {\n    position: absolute;\n    top: 3.75em;\n    left: 0.25em;\n    width: 200px;\n    height: 200px;\n    background-color: white;\n    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.5);\n    border: 1px solid var(--border-color);\n}\n\ndiv.overview-map.ol-collapsed > div.ol-overviewmap-map {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
